import React, { FunctionComponent } from 'react'
import { useHistory } from 'react-router'
import * as S from './styled'

type OwnProps = {}

type Props = OwnProps

export const CreateDocumentButton: FunctionComponent<Props> = () => {
  const history = useHistory()
  const productTranslation = {
    eggs: 'Ägg',
    oats: 'Havre',
    raps: 'Raps',
    foder: 'Foder',
    diesel: 'Diesel',
  }

  function handleChange(event) {
    for (const [key, value] of Object.entries(productTranslation)) {
      event.target.value === value && history.push(`/createdocument/${key}`)
    }
  }
  return (
    <S.Container>
      <S.Dropdown onChange={handleChange}>
        <option hidden>Manuell Inmatning</option>
        {Object.entries(productTranslation).map(([key, value], i) => {
          return <S.Option key={i}>{value}</S.Option>
        })}
      </S.Dropdown>
    </S.Container>
  )
}

export default CreateDocumentButton
